import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const DocumentsTab = ({ documents }) => {
  const getFileIcon = (type) => {
    const icons = {
      'pdf': 'FileText',
      'doc': 'FileText',
      'docx': 'FileText',
      'image': 'Image',
      'video': 'Video'
    };
    return icons?.[type] || 'File';
  };

  const getFileColor = (type) => {
    const colors = {
      'pdf': 'text-red-600 bg-red-100',
      'doc': 'text-blue-600 bg-blue-100',
      'docx': 'text-blue-600 bg-blue-100',
      'image': 'text-green-600 bg-green-100',
      'video': 'text-purple-600 bg-purple-100'
    };
    return colors?.[type] || 'text-gray-600 bg-gray-100';
  };

  const handleDownload = (document) => {
    console.log('Downloading document:', document?.name);
  };

  const handleView = (document) => {
    console.log('Viewing document:', document?.name);
  };

  return (
    <div className="space-y-4">
      {documents?.length === 0 ? (
        <div className="text-center py-12">
          <Icon name="FileX" size={48} className="text-muted-foreground mx-auto mb-4" />
          <h3 className="text-lg font-medium text-foreground mb-2">No Documents</h3>
          <p className="text-muted-foreground">No additional documents have been uploaded.</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {documents?.map((document) => (
            <div key={document?.id} className="border border-border rounded-lg p-4 hover:shadow-sm transition-shadow duration-150">
              <div className="flex items-start justify-between mb-3">
                <div className="flex items-center space-x-3">
                  <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${getFileColor(document?.type)}`}>
                    <Icon name={getFileIcon(document?.type)} size={20} />
                  </div>
                  <div className="flex-1 min-w-0">
                    <h4 className="font-medium text-foreground truncate">{document?.name}</h4>
                    <p className="text-sm text-muted-foreground">
                      {document?.size} • {document?.uploadDate}
                    </p>
                  </div>
                </div>
              </div>

              {document?.description && (
                <p className="text-sm text-muted-foreground mb-3">{document?.description}</p>
              )}

              <div className="flex gap-2">
                <Button
                  variant="outline"
                  size="sm"
                  iconName="Eye"
                  iconPosition="left"
                  onClick={() => handleView(document)}
                  className="flex-1"
                >
                  View
                </Button>
                <Button
                  variant="outline"
                  size="sm"
                  iconName="Download"
                  iconPosition="left"
                  onClick={() => handleDownload(document)}
                  className="flex-1"
                >
                  Download
                </Button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default DocumentsTab;